import styled from "styled-components";

const FeaturesStyleWrapper = styled.section`
  padding-top: 110px;
  background-color: #0d102d;

  .features_items_row {
    row-gap: 30px;
    margin-top: 60px;
  } 


  @media only screen and (max-width: 1200px) {
    .features_title{
      width: 100%;
    }
  }

  @media only screen and (max-width: 667px) {
    padding-top: 80px;
  }

  @media only screen and (max-width: 480px) {
    padding-top: 60px;
  }


 
`;

export default FeaturesStyleWrapper;
